import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel';

const RuleMapEditor = (props) => {
    const { formObject } = props;
    return (

        <div >
            <div className="uiSpacer10">
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mapTagType" }} value="Tag Type Id" />
                </span>
                <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p" action={{
                    InputType: "ac", paramName: "mapTagType", acMethod: "Category", acDepCtrl: {}
                }}
                />
            </div>
            <div className="uiSpacer10">
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mapTag" }} value="Tag Id" />
                </span>
                <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p" action={{
                    InputType: "ac", paramName: "mapTag", acMethod: "CategoryDetail", acDepCtrl: { dparam: "#mapTagType" }
                }}
                />
            </div>
        </div>
    )
}

export default withView(RuleMapEditor, "ruleTag", "ruleTag")